import { NavLink } from 'react-router-dom';

// Two-home top level (Projects / Profile) per the IA redesign design doc
// (§3, §7-Brief-A). Check-in is still a temporary tab pending its own
// re-home call (not yet decided — do not remove without an explicit brief).
// Photos removed entirely per W.7 (feature teardown, not a re-home). Chat
// was re-homed under Brief C: general chat retired, replaced by
// project-scoped WorkoutChat entries (Dashboard, CheckIn) and the read-only
// coach-notes feed on /profile, so its tab is gone. Coach and Settings no
// longer get standalone tabs — both are reachable from /profile now.
const TABS: Array<{ to: string; label: string; title?: string }> = [
  { to: '/dashboard', label: 'Projects' },
  { to: '/profile', label: 'Profile' },
  { to: '/checkin', label: 'Check-in' },
];

export function TabBar() {
  return (
    <nav className="tabbar" aria-label="Primary">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) => `tab${isActive ? ' tab--active' : ''}`}
          title={t.title}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
